import React from 'react';
import { useAuth } from '@store/authStore';
import HolidayCalendarView from '@pages/employee/HolidayCalendarView';

const HolidayCalendarViewRouter: React.FC = () => {
  const { user } = useAuth();

  console.log('HolidayCalendarViewRouter: User role:', user?.role);

  // All roles (Admin, HR, Program Manager, Employee) now use the same employee-style Holiday Calendar View
  // This provides a consistent experience with /holidays navigation for all users
  console.log('HolidayCalendarViewRouter: Rendering Holiday Calendar View');
  return <HolidayCalendarView />;
};

export default HolidayCalendarViewRouter;
